import React from "react";
import { Field } from "formik";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import { ListSubheader, TextField, InputAdornment, Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import SearchIcon from "@mui/icons-material/Search";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const MultipleSelectCheckmarks = (props) => {
    const {name, options, placeholder, isDisabled, style, ...rest } = props
    const [searchText, setSearchText] = React.useState("");

    const displayedOptions = React.useMemo(
        () => options.filter((option) => containsText(option.label, searchText)),
        [searchText, options]
    );
    return (
        <Field name={name} {...rest}>
            {({ field, form: { setFieldValue } }) => {
               
                return (
                    <div style={style}>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <InputLabel id={`${name}-label`}>Tag</InputLabel>
                            <Select
                                {...field}
                                multiple
                                id={name}
                                labelId={`${name}-label`}
                                value={field.value || []}
                                onChange={(event) => setFieldValue(name, event.target.value)}
                                input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value.value} label={value.label} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                                disabled={isDisabled}
                                onClose={() => setTimeout(() => setSearchText(""), 50)}
                            >
                                <ListSubheader>
                                    <TextField
                                        size="small"
                                        autoFocus
                                        placeholder={placeholder}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            setSearchText(e.target.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key !== "Escape") {
                                                e.stopPropagation();
                                            }
                                        }}
                                    />
                                </ListSubheader>
                                {displayedOptions.map((option) => (
                                    <MenuItem key={option.value} value={option}>
                                        <Checkbox
                                            checked={field.value?.some(
                                                (item) => item.value === option.value
                                            )}
                                        />
                                        <ListItemText primary={option.label} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                );
            }}
        </Field>
    );
};

export default MultipleSelectCheckmarks;
